import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DataTableRepository from "../Repositories/DataTableRepository";

class DataTableBloc {
  rowtableChannel = new Subject();
  workUnitChannel = new Subject();
  listAtasanChannel = new Subject();
  inactiveChannel = new Subject();
  activeChannel = new Subject();
  generateChannel = new Subject();
  exportChannel = new Subject();
  verifikasiChannel = new Subject();
  cekVerifikasiChannel = new Subject();
  detailBobotChannel = new Subject();
  repository = new DataTableRepository();
  openverificationChannel = new Subject();
  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.listAtasanChannel.next({ status: apiResponse.INITIAL });
    this.inactiveChannel.next({ status: apiResponse.INITIAL });
    this.activeChannel.next({ status: apiResponse.INITIAL });
    this.generateChannel.next({ status: apiResponse.INITIAL });
    this.verifikasiChannel.next({ status: apiResponse.INITIAL });
    this.cekVerifikasiChannel.next({ status: apiResponse.INITIAL });
    this.detailBobotChannel.next({ status: apiResponse.INITIAL });
    this.exportChannel.next({ status: apiResponse.INITIAL });
    this.openverificationChannel.next({ status: apiResponse.INITIAL })

  }

  fetchRowTable = async (query, cancelToken) => {
    this.rowtableChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchRowTable(query, cancelToken)
        .then((result) => {
          this.rowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchWorkUnit = async (query, cancelToken) => {
    this.workUnitChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchWorkUnit(query, cancelToken)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchAtasan = async (query, cancelToken) => {
    this.listAtasanChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchAtasan(query, cancelToken)
        .then((result) => {
          this.listAtasanChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listAtasanChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchInactive = async (query) => {
    this.inactiveChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchInactive(query)
        .then((result) => {
          this.inactiveChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.inactiveChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchActive = async (query) => {
    this.activeChannel.next({ status: apiResponse.LOADING });
    try {
      await this.repository
        .fetchActive(query)
        .then((result) => {
          this.activeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.activeChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchRegenerate = async (query) => {
    try {
      this.generateChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchGenerate(query)
        .then((result) => {
          this.generateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.generateChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };

  fetchVerifikasi = async (query) => {
    try {
      this.verifikasiChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchVerifikasi(query)
        .then((result) => {
          this.verifikasiChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.verifikasiChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };
  openVerification = async (query) => {
    try {
      this.openverificationChannel.next({ status: apiResponse.LOADING })
      await this.repository.openVerification(query).then((result) => {
        this.openverificationChannel.next({ status: apiResponse.COMPLETED, data: result })
      }).catch((error) => {
        this.openverificationChannel.next({ status: apiResponse.ERROR, data: error })
      })
    } catch (error) { console.log("rxjs", "channel unsubscriber") }
  }
  cekVerifikasi = async (query) => {
    try {
      this.cekVerifikasiChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .cekVerifikasi(query)
        .then((result) => {
          this.cekVerifikasiChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.cekVerifikasiChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };

  fetchExport = async (query) => {
    try {
      this.exportChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExport(query)
        .then((result) => {
          this.exportChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };

  fetchBobot = async (query) => {
    try {
      this.detailBobotChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchBobot(query)
        .then((result) => {
          this.detailBobotChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailBobotChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscriber");
    }
  };
}

export default DataTableBloc;
